<template>
  <div class="my-center">
    <Row class="mem-tabs" type="flex" justify="start">
      <div
        v-for="(item,index) in tabList"
        :key="index"
        class="tab-item cursor"
        :class="filter.status === item.value ? ['active'] : ''"
        @click="activeChange(item.value)"
      >
        <span>{{item.key}}</span>
      </div>
    </Row>
    <!-- <z-tabs :tabLists="tabLists" v-model="indexVal" :activeIndex="indexVal"></z-tabs> -->
    <div class="my-center-main">
      <!-- <personal class="animated fast fadeIn" :info="info" v-show="filter.status === 1"></personal> -->
      <account class="animated fast fadeIn" :info="info" :activeIndex="filter.status" v-show="filter.status === 0 || filter.status === 1"></account>
      <designer class="animated fast fadeIn" v-show="filter.status === 2"></designer>
    </div>
  </div>
</template>

<script>
import personal from "./common/personal";
import account from "./common/account";
import designer from "./common/designer";
export default {
  data() {
    return {
      filter: {
        status: 0
      },
      // tabLists: ["基本资料", "实名认证", "设计师认证"],
      tabList: [
        { key: "个人实名认证", value: 0 },
        { key: "企业授权认证", value: 1 },
        { key: "设计师认证", value: 2 }
      ],
      indexVal: 1
    };
  },
  components: {
    personal,
    account,
    designer
  },

  computed: {
    info() {
      return this.$store.state.user.info;
    }
  },

  methods: {
    activeChange(val) {
      this.filter.status = val;
    }
  },

  created() {
    if (this.$route.query.index) {
      this.indexVal = Number(this.$route.query.index);
      this.filter.status = Number(this.$route.query.index)
    }
    this.$store.dispatch("getUser");
  }
};
</script>
<style lang="scss">
.my-center {
  position: relative;
  background: rgba(250, 250, 250, 1);
  height: 1200px;
  .my-center-main {
    background: #fff;
    border-radius: 4px;
    width: 1200px;
    position: absolute;
    left: 0px;
    padding: 130px 50px;
    min-height: 750px;
    padding-bottom: 150px;
    padding-top: 100px;
  }
}
</style>


